import * as types from './mutation_types'

export const preparePage = ({commit}) => {
  commit(types.DONATE_SHOW_TOGGLE_LOADING)
}
